<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="70%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="7">
                            <sys-select-teacher
                                :model.sync="model.teacher_id"
                                :error="errors.teacher_id && errors.length > 0" 
                                :data.sync="model.teacher"
                                :selectedObject.sync="teacherSelected" 
                                :errors="errors.teacher_id"
                                label="Professor*"
                                autoComplete
                                autofocus
                                :disabled="disabled || teacher != null"
                            />
                        </v-col>
                        <v-col cols="12" sm="5">
                            <sys-select-teacher-contract
                                :model.sync="model.teacher_contract_id"
                                :error="errors.teacher_contract_id && errors.length > 0" 
                                :errors="errors.teacher_contract_id"
                                label="Matrícula"
                                autoComplete
                                autofocus
                                filter-company
                                clearable
                                :disabled="disabled || !model.teacher_id"
                                :teacher-id="model.teacher_id"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <sys-select-campus
                                :model.sync="model.campus_id"
                                label="Campus"
                                dense
                                auto-complete
                                clearable
                                :disabled="disabled"
                                @change="onCampusChange"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <s-text-field
                                v-model="model.business_unit"
                                :error-messages="errors.business_unit"
                                label="Unidade Negócio"
                                dense
                                :disabled="disabled"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-course
                                :model.sync="model.course_id"
                                label="Curso"
                                dense
                                auto-complete
                                :disabled="disabled || !model.campus_id"
                                :campus-id="model.campus_id"
                                clearable
                            />
                        </v-col>
                        <v-col v-if="!isActivitiesType" cols="12" sm="3">
                            <sys-select-group
                                :model.sync="model.group_id"
                                label="Turma"
                                dense
                                auto-complete
                                clearable
                                :disabled="disabled || !model.course_id"
                                :campus-id="model.campus_id"
                                :course-id="model.course_id"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="isActivitiesType">
                        <v-col cols="12" sm="12">
                            <sys-select-activity
                                :model.sync="model.activity_id"
                                :error="!!errors.activity_id"  
                                :errors="errors.activity_id"
                                label="Atividade*"
                                itemText="name_complete"
                                autoComplete
                                :disabled="disabled"
                                dense
                            /> 
                        </v-col>
                    </v-row>

                    <v-row v-else>
                        <v-col cols="12" sm="12">
                            <sys-select-base
                                :model.sync="model.grid_id"
                                :items="grids"
                                :loading="loadingGrids"
                                label="Disciplina da turma (Grid)*"
                                autoComplete
                                :disabled="disabled || !model.group_id"
                                :clearable="true"
                                :error="!!errors.grid_id"
                                :errors="errors.grid_id"
                                itemText="text"
                                @change="onGridChange"
                            />
                        </v-col>
                    </v-row>
                    <v-row> 
                        <v-col cols="12" sm="4">
                            <sys-select-payment-periodicity-type
                                    :model.sync="model.payment_periodicity_type_id"
                                    :error="errors.length > 0"  
                                    :errors="errors.payment_periodicity_type_id"
                                    label="Periodicidade*"
                                    :disabled="disabled"
                                    dense
                                /> 
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-value-type
                                :model.sync="model.value_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.value_type_id"
                                label="Tipo de Valor*"
                                dense
                                :disabled="disabled"
                            /> 
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field
                                v-if="paymentExport.payment_export_prorated_type_id == 1"
                                v-model="model.value_prorated_grids"     
                                :error-messages="errors.value_prorated_grids" 
                                label="Valor*"
                                dense
                                :disabled="disabled"
                            />
                            <s-text-field
                                v-else-if="paymentExport.payment_export_prorated_type_id == 2"
                                v-model="model.value_prorated_students"     
                                :error-messages="errors.value_prorated_students" 
                                label="Valor*"
                                dense
                                :disabled="disabled"
                            />
                            <s-text-field
                                v-else
                                v-model="model.value"     
                                :error-messages="errors.value" 
                                label="Valor*"
                                dense
                                :disabled="disabled"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <emc-calendar-date-picker2 
                                :model.sync="model.start" 
                                label="Início*" 
                                :errorMessages="errors.start"
                                :show="dialog"
                                :min="acesso.periodo.start"
                                :max="acesso.periodo.end"
                                :disabled="disabled"
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <emc-calendar-date-picker2 
                                :model.sync="model.end" 
                                label="Fim*" 
                                :errorMessages="errors.end"
                                :show="dialog"
                                :min="acesso.periodo.start"
                                :max="acesso.periodo.end"
                                :disabled="disabled"
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-cost-center
                                :model.sync="model.cost_center_id"
                                :error="errors.length > 0"  
                                :errors="errors.cost_center_id"
                                label="Centro de Custo"
                                clearable
                                auto-complete
                                dense
                                :disabled="disabled || !!model.course_id"
                            /> 
                        </v-col>
                        <v-col cols="12" sm="3">
                            <sys-select-payment-event
                                :model.sync="model.payment_event_id"
                                :error="errors.length > 0"
                                :errors="errors.payment_event_id"
                                label="Evento de Pgto"
                                item-text="initials"
                                clearable
                                auto-complete
                                dense
                                :disabled="disabled"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.note"
                                :error-messages="errors.note" 
                                v-model="model.note" 
                                label="Observação"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                :disabled="disabled"
                                rows="2"
                                 />
                        </v-col>
                    </v-row>
                    <v-row v-if="model.details">
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.details" 
                                :error-messages="errors.details" 
                                v-model="model.details" 
                                label="Detalhes"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                disabled
                                rows="2"
                                 />
                        </v-col>
                    </v-row>

            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import state from '../../../modules/auth/store/state'
export default {
    name: "SysPaymentExportRegisterItem",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        // Vue 2 does not make newly-added object keys reactive.
        // Keep a stable model shape so fields like `model.group_id` correctly
        // enable/disable dependent selects.
        model: {
            id: null,
            payment_export_id: null,
            payment_export_item_status_id: null,

            teacher_id: null,
            teacher_contract_id: null,

            campus_id: null,
            course_id: null,
            group_id: null,
            grid_id: null,
            discipline_id: null,

            activity_id: null,
            activity_item_id: null,

            business_unit: null,
        },
        message: '',
        loading: false,
        workTime: state.acesso.periodo,
        teacherSelected: {},
        grids: [],
        loadingGrids: false,
    }),
    computed: {
      ...mapState('auth', ['acesso']),

      isActivitiesType(){
        if (this.paymentExport && this.paymentExport.type && this.paymentExport.type.type) {
            return this.paymentExport.type.type == 'activities';
        }

        // Fallback enquanto houver fluxos que ainda nao carregam type no backend.
        return this.paymentExport && [2, 12].includes(this.paymentExport.payment_type_id);
      },

      disabled(){
        return this.model && this.model.payment_export_item_status_id == 4;
      }
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            // Reset model keeping keys reactive.
            const baseModel = {
                id: null,
                payment_export_id: null,
                payment_export_item_status_id: null,

                teacher_id: null,
                teacher_contract_id: null,

                campus_id: null,
                course_id: null,
                group_id: null,
                grid_id: null,
                discipline_id: null,

                activity_id: null,
                activity_item_id: null,

                business_unit: null,
            };

            this.model = { ...baseModel };

                if(show_new){
                
                this.error = false;
                this.errors = {};

                if(!this.item.id){
                    this.model = {
                        ...baseModel,
                        start: this.workTime.start,
                        end: this.workTime.end,
                        value_type_id: 1,
                        payment_periodicity_type_id: 1,
                    };
                }else{
                    // Replace the object so Vue can react to all properties.
                    this.model = { ...baseModel, ...this.item };
                }

                // Evita manter vínculos escondidos no modal (ex.: item antigo com group/grid)
                // quando a folha for do tipo activities.
                if(this.isActivitiesType){
                    this.model.grid_id = null;
                    this.model.group_id = null;
                    this.model.discipline_id = null;
                    this.grids = [];
                }

                // Garante que o PaymentType esteja carregado no objeto da folha.
                if(this.paymentExport && (!this.paymentExport.type || !this.paymentExport.type.type)){
                    // Fallback: em alguns fluxos a folha pode vir sem o relacionamento carregado.
                    // Nesse caso, mantém a UI pelo payment_type_id.
                }

            }
        },

        'model.group_id'(val, oldVal){
            if(val !== oldVal){
                // Only clear grid when user actually changes the group.
                // During modal initialization oldVal is typically null.
                if(oldVal != null){
                    this.model.grid_id = null;
                }
                this.grids = [];

                if(val && !this.isActivitiesType){
                    this.fetchGridsByGroup(val);
                }
            }
        },
        
    },
    props: {
        item: {
            default: null
        },
        paymentExport: {
            required: true,
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-account-cash"
        },
        title: {
            type: String,
            default: "Registro de Pagamento"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            default: null
        }
    },
    methods:{
        ...mapActions('paymentExport', ['ActionUpdatePaymentExportItem', 'ActionCreatePaymentExportItem']),
        ...mapActions('grid', ['ActionFindGrids']),

        // Ao trocar o campus, substitui a Unidade de Negócio pela do campus selecionado.
        // O sys-select-base emite o objeto completo do campus no @change (com business_unit).
        onCampusChange(campus)
        {
            this.model.business_unit = campus && campus.business_unit ? campus.business_unit : null;
        },

        onGridChange(gridId)
        {
            // Se o usuário selecionar um grid, tentamos manter group_id/discipline_id consistentes.
            const selected = this.grids.find(g => g.id == gridId);
            if(selected){
                this.model.discipline_id = selected.discipline_id;
                this.model.group_id = selected.group_id;
                this.model.course_id = selected.group && selected.group.course_id ? selected.group.course_id : this.model.course_id;
                this.model.campus_id = selected.group && selected.group.campus_id ? selected.group.campus_id : this.model.campus_id;
            }
        },

        async fetchGridsByGroup(groupId)
        {
            this.loadingGrids = true;
            const payload = {
                column_order: 'id',
                direction: 'asc',
                per_page: 9999,
                page: 1,
                find_columns: {
                    group_id: groupId,
                },
                with: 'discipline,workLoadType,group',
            };

            await this.ActionFindGrids(payload)
                .then((res) => {
                    const data = res && res.data ? res.data : [];
                    // Monta um texto amigável para o select
                    this.grids = data.map((g) => {
                        const disciplineName = g.discipline ? g.discipline.name : (g.discipline_name || '');
                        const wl = g.work_load_type ? g.work_load_type.initials : null;
                        const groupNumber = (g.group_number !== null && g.group_number !== undefined) ? String(g.group_number) : null;
                        const teacherNumber = (g.teacher_number !== null && g.teacher_number !== undefined) ? String(g.teacher_number) : null;

                        const parts = [];
                        if(disciplineName) parts.push(disciplineName);
                        if(wl) parts.push(wl);
                        if(groupNumber) parts.push('Turma ' + groupNumber);
                        if(teacherNumber) parts.push('Prof ' + teacherNumber);

                        return {
                            ...g,
                            text: parts.length > 0 ? parts.join(' | ') : ('Grid #' + g.id),
                        };
                    });
                })
                .finally(() => {
                    this.loadingGrids = false;
                });
        },

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

                if(this.paymentExport){
                
                    this.model.payment_export_id = this.paymentExport.id;

                    // Garantir consistencia minima conforme tipo.
                    if(this.isActivitiesType){
                        this.model.grid_id = null;
                        this.model.group_id = null;
                        this.model.discipline_id = null;
                    }else{
                        this.model.activity_id = null;
                        this.model.activity_item_id = null;
                    }

                if(this.paymentExport.payment_export_prorated_type_id == 3 && this.model.value){
                    this.model.value_prorated_grids = this.model.value;
                    this.model.value_prorated_students = this.model.value;
                }
            }

            if(this.model && this.model.id) {
                this.ActionUpdatePaymentExportItem(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;

                    // errors pode vir como array (mensagens) ou como objeto por campo.
                    if(error && error.errors){
                        if(Array.isArray(error.errors) && error.errors.length > 0){
                            this.message = error.errors[0];
                        }else if(typeof error.errors === 'object'){
                            const firstKey = Object.keys(error.errors)[0];
                            const firstVal = firstKey ? error.errors[firstKey] : null;
                            this.message = Array.isArray(firstVal) && firstVal[0] ? firstVal[0] : (error.message || 'Erro ao salvar');
                        }else{
                            this.message = error.message;
                        }
                    }else{
                        this.message = error.message;
                    }

                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                
                
                
                this.ActionCreatePaymentExportItem(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error && error.errors ? error.errors : {};

                    if(error && error.errors){
                        if(Array.isArray(error.errors) && error.errors.length > 0){
                            this.message = error.errors[0];
                        }else if(typeof error.errors === 'object'){
                            const firstKey = Object.keys(error.errors)[0];
                            const firstVal = firstKey ? error.errors[firstKey] : null;
                            this.message = Array.isArray(firstVal) && firstVal[0] ? firstVal[0] : (error.message || 'Erro ao salvar');
                        }else{
                            this.message = error.message;
                        }
                    }else{
                        this.message = error.message;
                    }
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

        loadGroups(items){
            
            var course = this.courses.find(c => c.id == this.model.group.course_id);
            this.course = course;
            this.group_id = this.model.group_id;
        },

    }
}
</script>
